import { Component, EventEmitter, Input, Output } from '@angular/core';

export type Item = {
  name: string;
  charged: boolean;
  locked: boolean;
};

@Component({
  selector: 'gymfinder-options-checkboxes',
  templateUrl: './checkboxes.component.html',
  styleUrls: ['./checkboxes.component.scss'],
  standalone: false,
})
export class OptionsCheckboxesComponent<T extends Item> {
  @Input()
  name: string;

  @Input()
  editMode: boolean;

  @Input()
  selectedItems: T[] = [];

  @Input()
  allItems: T[] = [];

  @Input()
  getTranslation: (key: string) => string;

  @Output()
  itemsChange = new EventEmitter<T[]>();

  handleClickOnCheckboxElement = (item: T) => {
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.filter(a => a.name !== item.name);
    } else {
      this.selectedItems = [...this.selectedItems, item];
    }
    this.itemsChange.emit(this.selectedItems);
  };

  handleClickOnIcons = (item: T, field: 'charged' | 'locked') => {
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.map(i => ({
        ...i,
        [field]: i.name === item.name ? !i[field] : i[field],
      }));
      this.itemsChange.emit(this.selectedItems);
    }
  };

  isSelected = (item: T) => this.selectedItems.some(a => a.name === item.name);

  isCharged = (item: T) => this.isFieldTrueForSelectedItem(item, 'charged');

  isLocked = (item: T) => this.isFieldTrueForSelectedItem(item, 'locked');

  private isFieldTrueForSelectedItem = (item: T, field: 'charged' | 'locked') =>
    this.selectedItems.find(a => a.name === item.name)?.[field];
}
